/**
 * The map control (`@heroui-pro/react/map`, MapLibre). Places, routes, arcs and clusters come from the app's own data. The tiles
 * are fetched by the Workbench, never by the app: the style comes from the `apps.mapTiles` setting (OpenFreeMap's free, keyless
 * styles by default) and from the policy's `microapps.mapTiles` ("<style url>" or "off"), and with tiles off the node draws its
 * places as a list. The tile provider sees which area is being viewed; the policy's description says so.
 * OURS: the workbench defines this file; AIOE mirrors it.
 */
import { UI_LIMITS } from "../uiBase.js";
import { control } from "./kit.js";
const lat = (k) => k.z.number().min(-90).max(90);
const lng = (k) => k.z.number().min(-180).max(180);
export const MAP_CONTROLS = [
    control({
        type: "map",
        group: "map",
        heroui: "@heroui-pro/react/map Map (MapLibre)",
        summary: `map { caption?, rows | rowsFrom (places: { lat, lng, title?, description?, tone? }), keys?, routes?[{ label?, tone?, points[{ lat, lng }] }] | routesFrom (rows { route, lat, lng, order? }), arcs?[{ fromLat, fromLng, toLat, toLng, label? }] | arcsFrom, cluster?, center?: { lat, lng }, zoom?: 1-18, height?, onSelect? } — a map with markers and popups, routes, arcs and clusters (at most ${UI_LIMITS.mapPlaces} places). The Workbench fetches the tiles; with tiles off the places are listed. onSelect runs with the row of the place pressed.`,
        example: {
            type: "map",
            caption: "Our offices",
            rows: [
                { lat: -33.8688, lng: 151.2093, title: "Sydney", description: "Head office", tone: "teal" },
                { lat: -37.8136, lng: 144.9631, title: "Melbourne", tone: "violet" },
            ],
            routes: [{ label: "Courier", tone: "amber", points: [{ lat: -33.8688, lng: 151.2093 }, { lat: -35.2809, lng: 149.13 }, { lat: -37.8136, lng: 144.9631 }] }],
            arcs: [{ fromLat: -33.8688, fromLng: 151.2093, toLat: -37.8136, toLng: 144.9631, label: "Sync" }],
            height: 280,
        },
        shape: (k) => ({
            caption: k.hint.optional(),
            rows: k.rows(UI_LIMITS.mapPlaces),
            rowsFrom: k.rowsFrom,
            keys: k.keys,
            routes: k.z
                .array(k.z.object({ label: k.label.optional(), tone: k.tone.optional(), points: k.z.array(k.z.object({ lat: lat(k), lng: lng(k) }).strict()).min(2).max(200) }).strict())
                .max(8)
                .optional(),
            routesFrom: k.path.optional(),
            arcs: k.z.array(k.z.object({ fromLat: lat(k), fromLng: lng(k), toLat: lat(k), toLng: lng(k), label: k.label.optional() }).strict()).max(100).optional(),
            arcsFrom: k.path.optional(),
            cluster: k.z.boolean().optional(),
            center: k.z.object({ lat: lat(k), lng: lng(k) }).strict().optional(),
            zoom: k.z.number().min(1).max(18).optional(),
            height: k.z.number().int().min(160).max(640).optional(),
            onSelect: k.action.optional(),
        }),
    }),
];
//# sourceMappingURL=map.js.map